import React, { useState } from 'react'
import ModalInc from '../../../../../shared-ui/ModalInc'
import ButtonInc from '../../../../../shared-ui/ButtonInc'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Grid from "@material-ui/core/Grid";
import AlertDialog from '../../../../../components/AlertDialog/index.es6';
import { CircularProgress } from '@material-ui/core';

const AddClaimNotes = (props) => {
  const [notes, setNotes] = useState('');


  const handleChange = (event) => {
    const { name, value } = event.target

    if (name === "notes") {
      setNotes(value)
    }

  }
  const reset = () => {
    setNotes('');
  }
  const handleClaimNotes = () => {
    const payload = {
      "notes": notes,
      "claim_guid": props.claimguid
    }
    console.log("notes payload", payload);
    props.handleClaimNotes(payload)
    reset()
  }
  const handleNoteCreatedSuccessfully = () => {
    props.resetCreateNotesSuccessAlert();
    props.toggleClaimNotesDialog();
    window.location.reload();
  }
  const handleNoteCreateError = () => {
    props.resetCreateNotesErrorAlert();
  }
  return (
    <>
      <AlertDialog
        custom
        show={props.showCreateNoteProgressAlert}
        size="sm"
        style={{ marginTop: '0', top: '30vh' }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'cancel'}
        showTitle={false}
        confirmBtnCssClass
      >
        <CircularProgress />
        <h2> Creating Claim Note...</h2>
      </AlertDialog>

      <AlertDialog
        success
        show={props.showCreateNotesSuccessAlert}
        size="sm"
        title={'Claim note created'}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => { handleNoteCreatedSuccessfully() }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={true}
        cancelBtnText={'cancel'}
        confirmBtnCssClass
      >

      </AlertDialog>

      <AlertDialog
        show={props.showCreateNotesErrorAlert}
        danger
        title={'Error creating claim note'}
        onConfirm={() => handleNoteCreateError()}
        confirmBtnText={'Try again'}
        confirmBtnCssClass
        showCancel={false}
        style={{ marginTop: '0', top: '30vh' }}
      >

        {props.CreateNotesError ? props.CreateNotesError.message : ''}
      </AlertDialog>
      <ModalInc
        modalTitle="Add Claim Notes"
        subTitle="Fill the below field to add claim Notes"
        open={props.openClaimNotesDialog}
        onClose={props.toggleClaimNotesDialog}
        fullWidth
      >
        <ValidatorForm onSubmit={() => handleClaimNotes()} >

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <TextValidator
                name='notes'
                id="notes"
                label="Claim Notes"
                value={notes}
                onChange={handleChange}
                multiline
                rows={5}
                maxRows={4}
                fullWidth
                variant="outlined"
                validators={['required']}
                errorMessages={['Please enter claim Notes']}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} >
            <Grid item xs={12} sm={6} md={6}>

            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={8} md={8}>
                  <ButtonInc
                    variant="contained"
                    color="primary"
                    size="large"
                    type='submit'
                    style={{ marginTop: "20px", float: "right" }}
                  >
                    Add Notes
                  </ButtonInc>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <ButtonInc
                    variant="contained"
                    color="primary"
                    size="large"
                    style={{ marginTop: "20px" }}
                    onClick={props.toggleClaimNotesDialog}
                  >
                    Cancel
                  </ButtonInc>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

        </ValidatorForm>

      </ModalInc>
    </>
  )
}

export default AddClaimNotes